import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.erros.length > 0)?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VBtn,_vm._g(_vm._b({attrs:{"color":"error","dark":"","icon":"","x-small":""}},'v-btn',attrs,false),on),[_c(VIcon,[_vm._v("mdi-alert-circle")])],1)]}}],null,false,1383229041)},[_c('div',_vm._l((_vm.erros),function(erro,index){return _c('p',{key:index,staticClass:"ma-0 pa-0"},[_vm._v("- "+_vm._s(erro))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }